<template>
  <model-crud
    :model="model"
    :fields="fields"
    :include="['targets', 'certificates']"
  />
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import LineGroup from '@/models/LineGroup'
import UserCertificate from '@/models/UserCertificate'
import Line from '@/models/Line'

export default {
  data () {
    return {
      model: LineGroup,
      fields: {
        name: {
          label: this.$t('headers.name')
        },
        note: {
          label: this.$t('headers.note'),
          fill: true,
          multiLine: true,
          displayLength: 20
        },
        targets: {
          label: this.$t('headers.targets'),
          type: 'references',
          model: Line,
          fill: true,
          formOrder: 2
        },
        enabled: {
          label: this.$t('headers.enabled'),
          type: 'bool',
          default: true,
          formOrder: 1
        },
        certificates: {
          type: 'references',
          formOrder: 3,
          label: this.$t('headers.certificates'),
          list: false,
          fill: true,
          values: () => UserCertificate.getList({
            include: ['user']
          })
            .then(result => {
              return result.items.map(item => {
                item.name = item.user ? `${item.user.name} ${item.user.surname} - ${item.name}` : `? - ${item.name}`
                return item
              })
            })
        },
        recordAlways: {
          label: this.$t('headers.recordAlways'),
          type: 'bool',
          list: false,
          fill: true,
          formOrder: 4,
          default: true
        },
        timeFrom: {
          label: this.$t('headers.recordTimeFrom'),
          type: 'datedtime',
          list: false,
          requires: {
            recordAlways: false
          },
          formOrder: 4
        },
        timeTill: {
          label: this.$t('headers.recordTimeTill'),
          type: 'datedtime',
          list: false,
          requires: {
            recordAlways: false
          },
          formOrder: 4
        },
        daysOfWeek: {
          label: this.$t('headers.recordDaysOfWeek'),
          type: 'weekdays',
          list: false,
          fill: true,
          requires: {
            recordAlways: false
          },
          formOrder: 4
        }
      }
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// LineGroups.vue?44d3b565